import styled from 'styled-components';

export const DotBtn = styled.em` 
    display:block;
    width: calc(100vw*(3/375));
    height: calc(100vw*(15/375));
    object-fit: contain;
    margin-left : calc(100vw*(10.7/375));
`
export const Setlistinner = styled.ul`

`
export const Setlist = styled.li`
    height : calc(100vw*(43/375));
    border-bottom: solid  calc(100vw*(1/375)) #d8d8d8;
    padding : 0 calc(100vw*(17/375)) 0;
`
export const SetlistSpan = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width:100%;
`
export const Setlistname = styled.span`
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    color: #1d1d1d;
`
export const Setlistcont = styled.span`
    display: flex;
    align-items: center;
`

export const AddbtnBox = styled.span`
    display: flex;
    align-items: center;
    height: calc(100vw*(56/375));
    background-color: #f7f7f7;
    padding: 0 calc(100vw*(15/375));
`
export const Addbtn = styled.span`
    display:block;
    width: calc(100vw*(22/375));
    height :  calc(100vw*(22/375));
`
export const AddText = styled.p`
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    letter-spacing: 0.28px;
    color: #4e4e4e;
    margin-left : calc(100vw*(9/375));
`